module.exports = __webpack_public_path__ + "static/media/senegal3w.c30dfcd4.JPG";